module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-200.woff?7eef082fb93671877eff57d4ee4f3990";